import { lazy } from 'react'

export default lazy(
    () => 
    import('./WeightViewB2B') 
)